import { useEffect } from "react";
import { BUSINESS_NAME, DEFAULT_OG_IMAGE } from "@/lib/site";

type PageSEOOptions = {
  title: string;
  description: string;
  canonical: string;
  robots?: string;
  ogImage?: string;
  ogType?: "website" | "product";
};

function setMetaContent(name: string, content: string) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setMetaProperty(property: string, content: string) {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setCanonical(href: string) {
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export function usePageSEO({
  title,
  description,
  canonical,
  robots,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
}: PageSEOOptions) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = "pt-BR";

    setMetaContent("description", description);
    setMetaContent("title", title);
    setCanonical(canonical);
    setMetaContent("robots", robots ?? "index, follow");

    setMetaProperty("og:type", ogType);
    setMetaProperty("og:title", title);
    setMetaProperty("og:description", description);
    setMetaProperty("og:url", canonical);
    setMetaProperty("og:image", ogImage);
    setMetaProperty("og:locale", "pt_BR");
    setMetaProperty("og:site_name", BUSINESS_NAME);

    setMetaContent("twitter:card", "summary_large_image");
    setMetaContent("twitter:title", title);
    setMetaContent("twitter:description", description);
    setMetaContent("twitter:image", ogImage);
    setMetaContent("twitter:url", canonical);
  }, [title, description, canonical, robots, ogImage, ogType]);
}
